export default {
  'm': {
    'uploading': 'Téléchargement...',
    'upload_failed': 'Échec du téléchargement',
    'EnterID': 'Cliquez pour entrer l\'identifiant de BuzzCast ',
    'select-specifications': 'Cliquez pour sélectionner les spécifications de recharge',
    'check-account': 'Vérifiez le compte de recharge',
    'whatID': 'Qu\'est-ce que l\'identifiant de BuzzCast?',
    'getID': 'Entrez l\'identifiant de BuzzCast',
    'maskgetID': 'Entrez l\'identifiant de BuzzCast',
    'toastTips-format-error': 'Format d\'entrée incorrect',
    'toastTips-no-exist': 'Cet identifiant n\'existe pas',
    'toastTipsPlease': 'Veuillez d\'abord vérifier le compte de recharge',
    'common-problem': 'Problèmes communs',
    'transaction-succeeded': 'Transaction réussie',
    'transaction-failed': 'Transaction échouée',
    'transaction-cancel': 'Transaction annulée',
    'whether-account': '1.Comment vérifier si c\'est crédité après la recharge?',
    'answer-whether-account': 'Après la recharge, vous pouvez revenir à [Moi] - [Portefeuille] dans l\'application pour vérifier les diamants',
    'no-account': '2.Et comment faire si le compte n\'est pas crédité après la recharge?',
    'answer-no-account': 'Veuillez soumettre vos questions dans [Messages] - [Messages officiels] - [Commentaires et aide] de l\'application, et fournir les informations suivantes, notre service client vous aidera.',
    'recharge-money': '1. Montant de la recharge et identifiant du compte',
    'recharge-time': '2. Heure et date de recharge',
    'recharge-shot': '3. Capture d\'écran du paiement réussi',
    'recharge-wrong': '3. Que dois-je faire si je recharge le compte incorrect ou le montant incorrect ?',
    'answer-recharge-wrong': 'Avant d\'entrer le mot de passe de paiement, veuillez vous assurer de bien confirmer l\'identifiant du compte de recharge et les informations sur le montant de la recharge avant d\'effectuer un achat. Le montant de recharge incorrect ne peut pas être remboursé. Pour un compte erroné, vous pouvez essayer de contacter l\'utilisateur réel et négocier avec lui s\'il peut compenser votre charge.',
    'refund': '4.Remboursement',
    'answer-refund': 'Désolé! BuzzCast ne supporte pas actuellement aucune forme de remboursement.',
    'buy-enter-link': 'Les diamants d\'achat peuvent être rechargés via le lien,<a class="web-link" href="https://pay.buzzcast.info">https://pay.buzzcast.info</a> Copiez le lien dans le navigateur sur votre portable pour l\'ouvrir, accédez à la page d\'achat, après avoir vérifié le compte, sélectionnez les spécifications correspondantes et utilisez le mode de paiement approprié pour payer ~ Beaucoup de rabais!',
    'buy-notice-a': 'Attention: <a>{msg}</a> est le seul site officiel d\'achat de diamants de BuzzCast',
    'replace': 'Changer',
    'sureBtn': 'Oui',
    'pay-style': 'Choisissez le mode de paiement',
    'goBack': 'Retour à la page d\'accueil',
    'toastTips': 'Entrez l\'identifiant de BuzzCast ',
    'rechargeFAQ_title': 'Problèmes communs',
    'PayStatusSuccess_title': 'Transaction réussie',
    'PayStatusFail_title': 'Transaction échouée',
    'PayStatusCancel_title': 'Transaction annulée',
    'Diamonds_title': 'Site officiel de recharge de diamant de {msg}',
    'buy-notice': 'Remarque pay.buzzcast.info est le seul site officiel d’achat de diamants de BuzzCast, veuillez consulter The Message - Official News - Feedback and Help',
    'RechargeHelp_title': 'Aide rechargement',
    'RechargeProblem_title': 'Votre rechargement a rencontré un problème,',
    'feedback_and_help': 'Commentaires et aides',
    'problem_screenshot': 'Capture d\'écran/enregistrement d\'écran de la question ({msg})',
    'problem_description': 'Description des questions',
    'problem_description_placeholder': 'Veuillez décrire la question que vous avez rencontrée',
    'optional': 'facultatif',
    'required': 'requis',
    'openAPP': 'Ouvrez l\'application BuzzCast',
    'buy-diamonds-tit': 'Acheter des services de diamants',
    'description': 'BuzzCast est le seul site officiel de recharge de diamants, BuzzCast est un logiciel social international, les utilisateurs de plus de 150 pays et régions du monde utilisent BuzzCast.',
    'keywords': 'Recharge de BuzzCast, recharge de diamant de BuzzCast, recharge officielle de BuzzCast, site officiel de recharge de BuzzCast.',
    'payforType': ' Méthode de recharge',
    'trueText': ' Oui',
    'falseText': ' Annuler',
    'alertShowTxt1': ' Êtes-vous sûr d\'utiliser',
    'alertShowTxt3': ' pour recharger',
    'alertShowTxt5': ' diamants?',
    'EnterIDTip': 'Recharge rapide {msg}',
    'scanLogin': ' Pour la confidentialité et la sécurité du compte, veuillez scanner le code pour vous connecter',
    'scanTip': ' Astuce: Cliquez sur "Analyse" dans le coin supérieur droit de BuzzCast "Centre personnel/Dynamique" pour scanner le code pour vous connecter. En même temps, il prend en charge la connexion en identifiant la capture d\'écran du code QR',
    'scanVersion': ' Veuillez mettre à niveau BuzzCast vers la version %s et scannez le code pour vous connecter',
    'delAccount': ' Suppression de compte',
    'logout': ' Déconnexion',
    'submit': 'Soumettre',
    'email_place_holder': 'Entrez votre boîte aux lettres',
    'fill_in_email_address': 'Veuillez remplir l\'adresse e-mail',
    'fill_in_all_required': 'Veuillez saisir la description de la question',
    'order_exception_notice': "Rappel chaleureux: le numéro de commande ou la capture d'écran de la facture doivent être fournis pour les commandes de recharge anormales",
    'cannot_read_file': 'Impossible de lire le fichier',
    'upload_file_exceed_limit': 'Le fichier téléversé ne peut pas dépasser {num} Mo',
    'submitting': 'Envoi en cours...',
    'submit_failed': 'Échec de l\'envoi',
    'contact_email': 'Email du contact',
    'provide_email': 'Veuillez fournir votre adresse e-mail pour recevoir une notification de paiement',
    'email_address': 'Adresse e-mail',


    'sel_country_area': "Sélectionnez un pays ou une région",
    'search_for': "Recherche",
    'login': "S'identifier",
    'scan_login': "Connexion par code de numérisation",
    'account_password_error': "Numéro de téléphone ou code incorrect",
    'user_frozen': "Cet utilisateur est gelé",
    'account_no_reg': "Le compte n'est pas enregistré",
    'login_no': "Vous n'êtes pas connecté",
    'login_after_recharge': "Vous pouvez recharger après vous être connecté",
    'scan_login_lesson': "Tutoriel de numérisation de connexion par code",
    'scan_login_desc': "La méthode de numérisation de code de connexion peut être réalisée rapidement et en toute sécurité pour vous connecter au site Web de recharge. Les deux méthodes suivantes présenteront respectivement comment scanner le code pour se connecter.",
    'scan_login_a_title': "Connectez-vous en reconnaissant les captures d'écran du code QR",
    'scan_login_a_p1': "1. Il est plus approprié d'utiliser le scénario d'un seul appareil. L'utilisateur entre dans la page de connexion du site Web de recharge, clique pour sélectionner \"Scanner le code pour se connecter\", et prend une capture d'écran de la page avec le code QR de connexion qui s'affiche et enregistre l'album. (La fonction de capture d'écran est légèrement différente pour différents appareils, vous pouvez rechercher vous-même les instructions de fonctionnement de la fonction de capture d'écran)",
    'scan_login_a_p2': "2. Ouvrez l'application BuzzCast, via le module de fonction «Centre personnel» ou «Dynamique», cliquez sur «Scan» dans le coin supérieur droit pour accéder au module de fonction de numérisation de code.",
    'scan_login_a_p3': "3. Cliquez sur \"Sélection d'album\" et autorisez les autorisations d'album, sélectionnez la capture d'écran de la page de connexion du code QR enregistrée, cliquez sur le bouton de confirmation \"Connexion\" une fois que le système a reconnu, revenez au navigateur et attendez un moment, la page se chargera automatiquement de l'utilisateur informations.",
    'scan_login_b_title': "Connectez-vous en scannant le code QR",
    'scan_login_b_p1': "1. Il est plus adapté à l'utilisation de plusieurs appareils. L'utilisateur entre dans la page de connexion du site Web de recharge et clique pour sélectionner «Scan code login",
    'scan_login_b_p2': "2. Ouvrez l'application BuzzCast sur un autre appareil, accédez au module de fonction «Centre personnel» ou «Dynamique» et cliquez sur «Numériser» dans le coin supérieur droit pour accéder au module de fonction de numérisation de code.",
    'scan_login_b_p3': "3. Alignez la boîte de numérisation de code avec le code QR sur la page de connexion de numérisation de code, cliquez sur le bouton de confirmation «connexion» une fois que le système l'a reconnu (il est recommandé de garder une certaine distance entre les appareils lors de la numérisation du code, ce qui est plus facile que le système reconnaît). Après un certain temps, la page chargera automatiquement les informations de l'utilisateur.",
    'scan_login_lesson_end': "Ce qui précède est un guide didacticiel pour la numérisation de code de connexion, j'espère vous aider. Pour la consultation du service client, veuillez entrer le message de l'APP-informations officielles-commentaires et aide.",
    'or': "Ou",
    'input_phone_num': "Le numéro de téléphone ne peut pas être vide",
    'input_email': "Veuillez saisir votre adresse e-mail",
    'input_password': "Tapez votre code",

    'log_in_using_Facebook': 'Connectez-vous avec Facebook',
    'log_in_using_Google': 'Connectez-vous avec Google',
    'account_or_pwd_error': 'Compte ou mot de passe incorrect',

    'pay_fail_system_risk': 'La transaction a échoué: système anormal',

    'recharge_fail_risk_network': 'Le rechargement a échoué. Vous êtes peut-être dans un environnement réseau à haut risque ou pour d\'autres raisons. Si vous avez besoin d\'aide pour le rechargement, veuillez nous signaler votre problème.',

    'friendly_tip': 'Astuce chaude',
    'i_got_it': 'Je l\'ai',
    'android_fblogin_tip': 'Étant donné que Facebook ne prend plus en charge la connexion par authentification sur le navigateur intégré Android, il se peut que vous ne puissiez pas vous connecter lorsque vous vous connectez de cette manière. Si vous rencontrez ce type de problème de connexion, veuillez utiliser le navigateur Chrome pour y accéder.',
    'recharge_tip': 'La quantité spécifique de diamants qui ont été sur le compte est soumise au montant réel de la recharge',

    'charge': 'Recharge',
    'link_add_mainpage': 'Ajoutez un lien vers votre écran d\'accueil pour votre prochaine charge',
    'click_me_to_add': 'Cliquez sur moi pour ajouter',

    'user_has_delete': "L'utilisateur a été annulé",

    'support_contant_whatsapp': 'Si vous avez besoin d\'aide, veuillez contacter le service client sur {msg} App：1924383',



    'buy_balance': 'Solde achetable:',
    'official_coin_seller': 'Marchand de pièces officiel',
    'paystyle_unavailabel_change_other': 'Le système est anormal, ce mode de paiement est temporairement indisponible, vous pouvez passer à d\'autres modes de paiement.',
    'failedPay': 'Problème de paiement, re - paiement',
    "copied": "Copié",
    "reseller": "Revendeur",
    "netword_busy_try": "Le réseau est occupé, veuillez réessayer",
    "placecommen": 'Entrez les mots à rechercher',
    "app_all_v2": 'Tous',

		"use_phone_login": `Se connecter avec téléphone`,
    "use_email_login": `Se connecter avec e-mail`,
    "device_is_more": "Le nombre de comptes enregistrés pour cet appareil a atteint la limite supérieure",
    "Operation_failed": "Cet appareil a été gelé en permanence en raison de violations de compte.",
    "connection_fail_retry_feedback": "Échec de la connexion. Veuillez vous assurer que le réseau fonctionne correctement et réessayez. Si vous rencontrez toujours des erreurs, veuillez nous les signaler, et nous les résoudrons pour vous dans les plus brefs délais",
    "fawry_recharge_failed": "La recharge de ${msg} via {method} n'a pas réussi.",
    "feedback": "Retour d'information",
    "problem_feedback": "Feed-back",
    "recommended_recharge_methods": "Moyens de paiement recommandés",
    "try_recharge_methods": "Veuillez essayer de recharger en utilisant les méthodes suivantes. Si vous rencontrez toujours des problèmes, cliquez sur le bouton \"{feedback}\" ci-dessous pour nous contacter.",
    "unable_recharge": "Impossible de recharger",
    "submitted_successfully": "Soumettre avec succès",
    "feedback_success_tip": "Merci pour vos commentaires, nous les traiterons dans les plus brefs délais dans les 24 heures",
    "completed": "Complet",
    'contact_information': 'Coordonnées (facultatif)',
    'pay_failed': 'Échec du paiement',
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/fr.js